<header>
  <div class="container">
    <h3  >Dziękujemy! To już koniec pytań.</h3>
    <h3  >Na podstawie Twoich odpowiedzi rekomendujemy zakup:</h3>
    <h2  ><b>{{plaster.plasterType | plasterType:1}}</b></h2>
  </div>
</header>
<main class="questionnaire-summary">

  <article>
    <section>


      <mat-accordion class="example-headers-align"  >
        <mat-expansion-panel [expanded]="step() === 0"  >
          <mat-expansion-panel-header>
            <mat-panel-title> Rekomendowany produkt </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>

                      <div class="row">
                        <div class="col-md-4 col-xs-12 pic">
                          <img src="{{plaster.imageFile}}" class="img-fluid" />

                            <a class="btn btn-info"   (click)="openModal('selectother')">Sprawdź inne</a>
                          <br/>
                          <br/>

                        </div>
                        <div class="col-md-8 col-xs-12">
                          <h3>{{plaster.name}}</h3>
                          <p>{{plaster.description}}</p>
                          <p *ngIf="plaster.caution" class="plaster-caution">
                            <b>Uwaga!</b> {{plaster.caution}}
                          </p>
                          <p class="plaster-notice">
                            <b>Pamiętaj!</b> {{plaster.notice}}
                          </p>
                        </div>
                      </div>


        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Polecany produkt do wykończenia </mat-panel-title>

          </mat-expansion-panel-header>

                      <div class="row">
                        <div class="col-md-4 col-xs-12">
                          <img src="assets/photos/wiadro_mosaic.png" class="img-fluid" />

                        </div>
                        <div class="col-md-8 col-xs-12">
                          <h2>Do wykończenie detali elewacji – cokołów, szczytów i naroży fasad
                            oraz strefy wejściowej polecamy:</h2>
                          <h3>Tynk mozaikowy Knauf Mosaic</h3>
                          <p>
                            Tynk Mosaic produkowany jest na bazie wysokiej jakości kolorowych kruszyw, zatopionych w bezbarwnej żywicy
                            silikonowo-akrylowej, dzięki temu pozwala uzyskać wyjątkowy efekt dekoracyjny, który doskonale podkreśli detale elewacji. Jest
                            najbardziej odporny ze
                            wszystkich tynków na działanie wody i uszkodzenia mechaniczne, dlatego wykorzystuje się go do zabezpieczenia
                            cokołów i innych
                            miejsc narażonych na zniszczenia oraz zabrudzenia, np. w strefie wejściowej do domu.
                          </p>
                        </div>
                      </div>
        </mat-expansion-panel>
      </mat-accordion>


<!--      <mdb-accordion [multiple]="false">-->
<!--        <mdb-accordion-item [collapsed]="false">-->
<!--          <mdb-accordion-item-head>Rekomendowany produkt</mdb-accordion-item-head>-->
<!--          <mdb-accordion-item-body>-->

<!--            <div class="row">-->
<!--              <div class="col-md-4 col-xs-12 pic">-->
<!--                <img src="{{plaster.imageFile}}" class="img-fluid" />-->

<!--                  <a class="btn btn-info"   (click)="openModal('selectother')">Sprawdź inne</a>-->
<!--                <br/>-->
<!--                <br/>-->

<!--              </div>-->
<!--              <div class="col-md-8 col-xs-12">-->
<!--                <h3>{{plaster.name}}</h3>-->
<!--                <p>{{plaster.description}}</p>-->
<!--                <p *ngIf="plaster.caution" class="plaster-caution">-->
<!--                  <b>Uwaga!</b> {{plaster.caution}}-->
<!--                </p>-->
<!--                <p class="plaster-notice">-->
<!--                  <b>Pamiętaj!</b> {{plaster.notice}}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mdb-accordion-item-body>-->
<!--        </mdb-accordion-item>-->

<!--        <mdb-accordion-item *ngIf="project.selectedMosaic != null">-->
<!--          <mdb-accordion-item-head>Polecany produkt do wykończenia</mdb-accordion-item-head>-->
<!--          <mdb-accordion-item-body>-->
<!--            <div class="row">-->
<!--              <div class="col-md-4 col-xs-12">-->
<!--                <img src="assets/photos/wiadro_mosaic.png" class="img-fluid" />-->

<!--              </div>-->
<!--              <div class="col-md-8 col-xs-12">-->
<!--                <h2>Do wykończenie detali elewacji – cokołów, szczytów i naroży fasad-->
<!--                  oraz strefy wejściowej polecamy:</h2>-->
<!--                <h3>Tynk mozaikowy Knauf Mosaic</h3>-->
<!--                <p>-->
<!--                  Tynk Mosaic produkowany jest na bazie wysokiej jakości kolorowych kruszyw, zatopionych w bezbarwnej żywicy-->
<!--                  silikonowo-akrylowej, dzięki temu pozwala uzyskać wyjątkowy efekt dekoracyjny, który doskonale podkreśli detale elewacji. Jest-->
<!--                  najbardziej odporny ze-->
<!--                  wszystkich tynków na działanie wody i uszkodzenia mechaniczne, dlatego wykorzystuje się go do zabezpieczenia-->
<!--                  cokołów i innych-->
<!--                  miejsc narażonych na zniszczenia oraz zabrudzenia, np. w strefie wejściowej do domu.-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </mdb-accordion-item-body>-->
<!--        </mdb-accordion-item>-->

<!--      </mdb-accordion>-->

    </section>
<!--    <div *ngIf="project.selectedMosaic != null">-->
<!--      <hr>-->
<!--      <section>-->
<!--        <h2>Do wykończenie detali elewacji – cokołów, szczytów i naroży fasad-->
<!--          oraz strefy wejściowej polecamy:</h2>-->
<!--        <h3>Tynk mozaikowy Knauf Mosaic</h3>-->
<!--        <img src="assets/photos/wiadro_mosaic.png" />-->
<!--        <p>-->
<!--          Tynk Mosaic produkowany jest na bazie wysokiej jakości kolorowych kruszyw, zatopionych w bezbarwnej żywicy-->
<!--          silikonowo-akrylo- -->
<!--          wej, dzięki temu pozwala uzyskać wyjątkowy efekt dekoracyjny, który doskonale podkreśli detale elewacji. Jest-->
<!--          najbardziej odporny ze-->
<!--          wszystkich tynków na działanie wody i uszkodzenia mechaniczne, dlatego wykorzystuje się go do zabezpieczenia-->
<!--          cokołów i innych-->
<!--          miejsc narażonych na zniszczenia oraz zabrudzenia, np. w strefie wejściowej do domu.-->
<!--        </p>-->
<!--      </section>-->
<!--    </div>-->
  </article>
  <aside>
    <ol>
      <li><span>Dom ocieplony:</span> {{project.ankieta.pytanie1a | izolacja}}</li>
      <li *ngIf="project.ankieta.pytanie2 != Otoczenie.invalid">
        <span>Lokalizacja:</span> {{project.ankieta.pytanie2 | lokalizacja}}
      </li>
      <li>
        <span>Faktura:</span> {{project.ankieta.pytanie3 | faktura}}
      </li>
    </ol>
  </aside>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>

<jw-modal id="selectother">
  <div *ngFor="let plaster of plasterReplacements, let last=last" class="zamiana">
    <div class="leaning">
      <a class="btn btn-primary"   (click)="changePlaster(plaster, 'selectother')">Zamień</a>
    </div>
    <h1>{{plaster.plasterType | plasterType}}</h1>
    <h3>{{plaster.name}}</h3>
    <hr *ngIf="!last">
  </div>
</jw-modal>
